var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"glossary-button",attrs:{"to":"/glossary","title":"Glossary"}},[_c('icon',{attrs:{"icon":"v2-book-round","colour":"transparent"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }